export default {
  initialMessage: "Hi, how can I help you?",
  placeholders: {
    writeMessage: "Write a message...",
  },
};
